module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.value))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fc97f2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Forms/Fields/f-id.vue
// module id = 525
// module chunks = 55